module.exports = __webpack_public_path__ + "static/media/go-share-white.bc7df408.svg";